export const TABLE_SEARCH_QUERY_PREFIX = 'table-'

export const columnSearchSchemaOptionType = {
  INPUT: 'input',
  NUMERIC_INPUT: 'numeric-input',
  DATE_RANGE: 'date-range',
  // TODO [MULTI_SELECT]: доработать, когда нужно будет использовать множественный select в поиске по таблице
  // MULTI_SELECT: 'multi-select',
  SELECT: 'select',
  NUMERIC_SELECT: 'numeric-select'
} as const
